<script>
import { connect } from 'vuex-connect';
import FilterBox from '../scenes/FilterBox.vue';

export default connect({
  gettersToProps: {
    tags: 'stationTags',
    disableFilter: 'disableFilter',
    disableSearch: 'disableSearch',
    dirty: 'isFilterDirty',
  },
  stateToProps: {
    filters: state => state.launcher.filters,
  },
  actionsToEvents: {
    change: 'onFiltersChange',
    clear: 'onFiltersClear',
  },
})('FilterBox', FilterBox);
</script>
